module.exports = __webpack_public_path__ + "static/media/chu_icon.52679a81.png";